module.exports = __webpack_public_path__ + "img/screen5.1c98456.png";